import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { IconModule } from '@freelancer/ui/icon';
import { IconColor, IconName, IconSize } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkUnderline,
  QueryParams,
  QueryParamsHandling,
} from '@freelancer/ui/link';
import { LinkModule } from '../link/link.module';

@Component({
  standalone: true,
  selector: `fl-more-options-item`,
  imports: [IconModule, LinkModule, NgTemplateOutlet],
  template: `
    @if (!iconName) {
      <fl-link
        class="ItemLink"
        [color]="LinkColor.INHERIT"
        [link]="link ? link : undefined"
        [queryParams]="queryParams"
        [queryParamsHandling]="queryParamsHandling"
        [newTab]="newTab"
        [underline]="LinkUnderline.NEVER"
        (click)="handleClick()"
      >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </fl-link>
    }

    @if (!!iconName) {
      <div
        class="ItemLinkWithIcon"
        [attr.data-row-hover]="true"
        (click)="handleClick()"
      >
        <fl-icon
          [useIconFont]="true"
          [fillIconFont]="false"
          [name]="iconName"
          [size]="iconSize"
          [color]="iconColor"
        ></fl-icon>
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    }

    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `,
  styleUrls: ['./more-options-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreOptionsItemComponent {
  LinkColor = LinkColor;
  LinkUnderline = LinkUnderline;

  @Input() link?: string;
  @Input() newTab?: boolean;
  @Input() queryParams?: QueryParams;
  @Input() queryParamsHandling?: QueryParamsHandling;
  @Input() iconName?: IconName;
  @Input() iconSize: IconSize = IconSize.LARGE;
  @Input() iconColor: IconColor = IconColor.FOREGROUND;
  @Input() disableCalloutClose = false;

  // FIXME: T300116 Enabling hydration errors on the webapp server
  // TypeError: Cannot read properties of null (reading 'parentElement')
  @HostBinding('attr.ngSkipHydration') skipHydration = 'true';

  @Output() itemSelected = new EventEmitter<void>();

  handleClick(): void {
    if (!this.disableCalloutClose) {
      this.itemSelected.emit();
    }
  }
}
